
import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import MenuBar from '../../components/MenuBar/MenuBar';
import { Alert, AlertCommit } from '../../Modals/AlertBar';
import DateTimeRange from '../../components/UserControl/DateTimeRange/DateTimeRange';
import { getMainCookie, checkStatus, getFullDate, checkText } from '../../../util/util';
import { TimePicker } from 'antd';
import $ from "jquery";

let startHistoryDate = null;
let endHistoryDate = null;
let token;
let fulPayment = null;
class Payment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentCarList: [],
            devices: [],
            selectDate: moment(),
            selectTime: moment(moment()).format("HH:mm"),
            bank: "",
            fileName: "",
            fileContent: ""
        };
    }
    componentDidMount() {
        let u = getMainCookie();
        //console.log("uuu",u)
        this.refs.txtPaymentName.value = u.first_name;
        token = u.token;
        this.getPaymentCar();
    }
    componentDidUpdate() {
    }

    getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      }

    getUploadFile() {
        let thisCur = this;
        return new Promise((resolve, reject) => {
            thisCur.state.fileName = "";
            thisCur.state.fileContent = "";
            let msg = "";
            let f = document.getElementById("fulPayment").files[0];

            if (f) {
                var r = new FileReader();
                r.onload = function (e) {
                    var contents = e.target.result;
                    // console.log(f.name, f.type, f.size, contents)
                    if (f.size > (1024 * 3) * 1000)
                        resolve("กรุณาเลือกไฟล์ ขนาดไฟล์ไม่เกิน 3 MB.");
                    else if (f.type == "image/jpeg" || f.type == "application/pdf" || f.type == "image/png" || f.type == "image/jpg") {
                        thisCur.state.fileName = f.name;
                        thisCur.getBase64(f).then(
                            data => {
                                thisCur.state.fileContent = data;
                                resolve("");
                            }
                        );
                        // thisCur.state.fileContent = 'data:image/svg+xml;base64,' + window.btoa(unescape(encodeURIComponent(contents)));
                        
                    } else {
                        resolve("กรุณาเลือกไฟล์ประเภท PDF หรือ JPG , JPEG , PNG เท่านั้น");
                    }
                }
                r.readAsText(f);
            } else {
                resolve("กรุณาเลือกไฟล์หลักฐานการโอน");
            }


        });

    }
    validateForm() {
        let msg = "";
        if (this.refs.txtPaymentName.value.trim() == "")
            msg = "กรุณาใส่ชื่อ";
        else if (this.refs.txtPaymentAmount.value.trim() == "")
            msg = "กรุณาใส่ยอดเงินที่โอน";
        else if (this.state.selectDate == "" || this.state.selectTime == "")
            msg = "กรุณาใส่ วัน เวลา ที่โอน";
        else if (this.state.bank == "")
            msg = "กรุณาใส่ธนาคารที่โอน";
        else if (this.refs.txtPaymentOriginateBanking.value.trim() == "")
            msg = "กรุณาใส่ธนาคารต้นทางที่โอน";

        if (msg != "")
            Alert(msg);

        return msg;
    }
    getPaymentCarSelect() {
        let thisCur = this;
        thisCur.state.devices=[];
        $(".chk-payment-car").each(function () {
            if (this.checked)
                thisCur.state.devices.push({ "device_id": this.id.split("_")[1] })

        });
        if (this.state.devices.length == 0) {
            Alert("กรุณาเลือกรถที่ชำระ")
            return "กรุณาเลือกรถที่ชำระ"
        } else
            return "";

    }

    newPayment() {
        let thisCur = this;
        fetch("http://203.150.199.244/api/admin/newPayment", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({
                "customer_name" : thisCur.refs.txtPaymentName.value.trim(),
                "amount" : thisCur.refs.txtPaymentAmount.value.trim(),
	            "transaction_dtm" : moment( thisCur.state.selectDate).format("DD-MM-YYYY") +" "+ thisCur.state.selectTime,
	            "banking": thisCur.state.bank,
	            "originate_banking" : thisCur.refs.txtPaymentOriginateBanking.value.trim(),
                "remark": thisCur.refs.txtPaymentRemark.value.trim(),
                "devices" : thisCur.state.devices,
                "attachs" : [
                    {
                        "name": btoa(unescape(encodeURIComponent(thisCur.state.fileName))),
                        "content" : thisCur.state.fileContent.split("base64,")[1]
                    }]
            })
        }).then(function (response) {
            return response.json();
        }).then((data) => {
            //console.log("data", data);
            if(data.RESULT_STATUS == "000")
                Alert("แจ้งชำระเงินเรียบร้อยแล้ว \nรหัสชำระเงินของท่านคือ " + data.RESULT_DATA[0].payment_id);
            else{
                AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
            }
        },
            (error) => {
                console.log("error", error)
                return error;
            }

        )
    
}
async btnPaymentClick() {
    if (this.validateForm() != "")
        return;
    if (this.getPaymentCarSelect() != "")
        return;
    let msg = await this.getUploadFile();
    if (msg != "") {
        Alert(msg)
        return;
    } else {
        this.newPayment();
    }
}


handleEndTimeHistoryChange(value) {
    this.state.selectTime = value.format('HH') + ":" + value.format('mm');
}


getPaymentCar() {
    let thisCur = this;
    fetch("http://203.150.199.244/api/report/deviceOverallSummary/PAYMENT/1/99999", {
        method: 'post',
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "token": token
        },
        body: JSON.stringify({})
    }).then(function (response) {
        return checkStatus(response);
    }).then((data) => {
        console.log("data", data)
        if (data.RESULT_DATA && data.RESULT_DATA.length>0 && data.RESULT_DATA[0].details && data.RESULT_DATA[0].details.length > 0) {
            $("#dvPaymentCarAll").show();
            thisCur.setState(
                {
                    paymentCarList: data.RESULT_DATA[0].details
                });
        }else{
            $("#dvPaymentCarAll").hide();
            Alert("ยังไม่พบรถที่ถึงกำหนดชำระเงิน");
        }
    },
        (error) => {
            console.log("error", error)
            return error;
        }

    )
}
handleChkPaymentCar(id) {
    //let isChk = $('#'+id).is(":checked");
    $("#chkPaymentCarAll").prop('checked', false);
}
handleChkPaymentCarAll(id) {
    let isChk = $('#' + id).is(":checked");
    $(".chk-payment-car").each(function () {
        this.checked = isChk;
    });
}

handleChangeDate(date) {
    this.setState({
        selectDate: date
    });

}

handlebankSelect(bank) {
    this.state.bank = bank;
}

render() {
    let rPaymentCar = [];
    this.state.paymentCarList.map((car, index) => {
        rPaymentCar.push(
            <tr>
                <td style={{ paddingTop: 5, textAlign: "center" }}>
                    <div className="checkbox" >
                        <label style={{ marginBottom: 0 }}>
                            <input type="checkbox" id={"chkPaymentCar" + index + "_" + car.device_id} defaultChecked={false} className={"chk-payment-car"}
                                onClick={this.handleChkPaymentCar.bind(this, "chkPaymentCar" + index + "_" + car.device_id)} />
                            <span className="cr" style={{ backgroundColor: "#fff" }}><i className="cr-icon fa fa-check"></i>
                            </span>
                        </label>
                    </div>
                </td>
                <td>
                    <label for={"chkPaymentCar" + index + "_" + car.device_id} style={{ width: "100%", marginBottom: 0 }}>{car.device_no}</label>
                </td>
                <td style={{ textAlign: "center" }}>
                    <label for={"chkPaymentCar" + index + "_" + car.device_id} style={{ width: "100%", marginBottom: 0 }}>{car.expire_date}</label>
                </td>
            </tr>
        )
    })

    return (
        <div >
            <MenuBar tab_payment="active" />
            <div style={{ marginTop: 60, marginLeft: 10, marginRight: 10 }}>
                <div className="card " >
                    <div className="card-header text-white" style={{ backgroundColor: "#ff7800" }}>
                        <h5 style={{ color: '#ffecc7' }}>
                            <i className="far fa-credit-card" aria-hidden="true" ></i>
                            <strong> แจ้งชำระเงิน</strong>
                        </h5>
                    </div>
                    <div className="card-body" style={{ paddingTop: 30 }}>

                        <div className="row">
                            <div className="col-md-6 mx-auto">
                                <form>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-md-4 col-form-label"><b>ชื่อ-นามสกุล <font style={{ color: "#dc0000" }}>*</font></b></label>
                                        <div className="col-md-8">
                                            <input ref="txtPaymentName"
                                                className="form-control"
                                                type="text"

                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-md-4 col-form-label"><b>รถที่ชำระ <font style={{ color: "#dc0000" }}>*</font></b></label>
                                        <div className="col-md-8">

                                            <div id="dvPaymentCarAll" className="checkbox" style={{ height: 20 }}>
                                                <label>
                                                    <input type="checkbox" id="chkPaymentCarAll" defaultChecked={false}
                                                        onClick={this.handleChkPaymentCarAll.bind(this, "chkPaymentCarAll")} />
                                                    <span className="cr" style={{ backgroundColor: "#fff" }}><i className="cr-icon fa fa-check"></i>
                                                    </span>
                                                </label>
                                                <label for={"chkPaymentCarAll"} style={{ top: -10 }}>
                                                    เลือกรถทั้งหมด
                                                    </label>
                                            </div>

                                            <div style={{ backgroundColor: "#fff", maxHeight: 300, overflowY: "auto" }}>
                                                <table className="table table-hover table-striped">
                                                    <thead>
                                                        <tr style={{ textAlign: "center" }}>
                                                            <th >#</th>
                                                            <th style={{ textAlign: "left" }}>ทะเบียน</th>
                                                            <th >วันครบกำหนด</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {rPaymentCar}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-md-4 col-form-label"><b>ยอดเงินที่โอน <font style={{ color: "#dc0000" }}>*</font></b></label>
                                        <div className="col-md-8">
                                            <input ref="txtPaymentAmount"
                                                className="form-control"
                                                type="text"

                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-md-4 col-form-label"><b>วันที่และเวลาที่โอนเงิน <font style={{ color: "#dc0000" }}>*</font></b></label>
                                        <div className="col-md-8">
                                            <table>
                                                <tr>
                                                    <td>
                                                        <DatePicker className="form-control" style={{ height: 32 }}

                                                            maxDate={moment()}
                                                            selected={this.state.selectDate}
                                                            onChange={this.handleChangeDate.bind(this)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <TimePicker allowEmpty={false} className="timeHistory" onChange={this.handleEndTimeHistoryChange.bind(this)} minuteStep={1} defaultValue={moment()} format={'HH:mm'} />
                                                    </td>
                                                </tr>
                                            </table>

                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-md-4 col-form-label"><b>ธนาคารที่โอนเงิน <font style={{ color: "#dc0000" }}>*</font></b></label>
                                        <div className="col-md-8">
                                            <div className="form-check">
                                                <label className="form-check-label">
                                                    <input type="radio" onClick={this.handlebankSelect.bind(this, "SCB")} className="form-check-input" name="optradio" />
                                                    <img src="./images/logo/scb.png" style={{ marginRight: 10 }}></img>
                                                    <b>ธนาคาร ไทยพาณิชย์</b><br />
                                                    ชื่อบัญชี : บริษัท xxxx จำกัด เลขที่บัญชี 093-2-466xxx-x
                                                    </label>
                                            </div>
                                            <div className="form-check">
                                                <label className="form-check-label">
                                                    <input type="radio" onClick={this.handlebankSelect.bind(this, "KBANK")} className="form-check-input" name="optradio" />
                                                    <img src="./images/logo/kbank.png" style={{ marginRight: 10 }}></img>
                                                    <b>ธนาคาร กสิกรไทย</b><br />
                                                    ชื่อบัญชี : บริษัท xxxx จำกัด เลขที่บัญชี 093-2-466xxx-x
                                                    </label>
                                            </div>
                                            <div className="form-check">
                                                <label className="form-check-label">
                                                    <input type="radio" onClick={this.handlebankSelect.bind(this, "PROMPT PAY")} className="form-check-input" name="optradio" />
                                                    <img src="./images/logo/prompt_pay_logo.png" style={{ marginRight: 10 }}></img>
                                                    <b>Promt Pay</b><br />
                                                    ชื่อบัญชี : บริษัท xxxx จำกัด เลขที่บัญชี 093-2-466xxx-x
                                                    </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-md-4 col-form-label"><b>ธนาคารต้นทางที่โอน <font style={{ color: "#dc0000" }}>*</font></b></label>
                                        <div className="col-md-8">
                                            <input ref="txtPaymentOriginateBanking"
                                                className="form-control"
                                                type="text"

                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-md-4 col-form-label"><b>หลักฐานการโอน <font style={{ color: "#dc0000" }}>*</font></b></label>
                                        <div className="col-md-8">
                                            <input id="fulPayment" type="file" style={{opacity:1}}  /><br />
                                            <b style={{ color: "#28a745", fontSize: 12 }}>ขนาดไฟล์ไม่เกิน 3 Mb และไฟล์ประเภท PDF หรือ JPG , JPEG , PNG เท่านั้น</b><br />
                                            <b style={{ color: "#dc3545", fontSize: 12 }}>การใช้หลักฐานปลอม มีความผิดตาม พรบ. คอมพิวเตอร์</b>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-md-4 col-form-label"><b>หมายเหตุ</b></label>
                                        <div className="col-md-8">
                                            <textarea class="form-control" rows="5" ref="txtPaymentRemark"></textarea>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer row" style={{ paddingBottom: 50 }}>
                        <div className="col-8 col-md-4 mx-auto">
                            <button type="button" class="btn btn-primary btn-lg btn-block" onClick={this.btnPaymentClick.bind(this)}> แจ้งโอนเงิน </button>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    );
}
}
export default Payment;


// WEBPACK FOOTER //
// ./src/app/view/containers/Payment/Payment.js